import { Injectable } from '@angular/core';
import { CustomerService } from '../customer.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OperationTypeService {

  private endpointPrefix = environment.apiUrl;
  constructor(private http: HttpClient, private customerService: CustomerService) { }

  public getAllOperationTypes(customerId: number | undefined, defaultValue: boolean = false) {
    let params: any = { option: defaultValue };

    if (customerId) {
      params.customerId = customerId;
    }
    return this.http.get(`${this.endpointPrefix}/operation-types`, { params });
  }

}
